// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"style_submitButton__2WfLQ","button":"style_button__1c-Vz","green":"style_green__qdvkT","purple":"style_purple__cIU_W"};